import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { YSButton } from "../../../uikit/YSButton";
import { Form, Formik } from "formik";
import {
  greyColor,
  warnColor,
  InputSMBoxStyle,
  BtnSMGroupStyle,
  LabelSMBoxStyle,
  HtmlTooltip,
  ContentStyle,
  DRxSelectStyle,
  DRxInputStyle,
} from "../../../Theme";
import { useLocation, useNavigate } from "react-router";
import InfoIcon from "../../../images/icons/InfoIcon.svg";
import { PatientInfoCard } from "../../../components/Content";
import { HelpGuideTooltip } from "../../../components/HelpGuideTooltip";
import DRxInput from "../../../uikit/DRxInput";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import { useSelector } from "react-redux";
import { RxAlertDetails } from "../../../Apis/AuthApiServices";
import useFetch from "../../../CustomHooks/useFetch";

export default function RxAlertsReview() {
  const AllDropdwonsState = useSelector((State: any) => {
    return { ...State.GlobalDropdownSlice.DropdownLists };
  }); //redux data

  const { state }: any = useLocation();

  const history = useNavigate();
  const Params = {
    doctorId: state?.rowData?.doctorId,
    messageId: state?.rowData?.messageId,
  };
  const { data: rxalertsDetails, loading }: any = useFetch(
    Params,
    RxAlertDetails,
    []
  );

  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Rx Alerts{" "}
          <HelpGuideTooltip
            content={
              <>
                {" "}
                <Typography component="div" variant="body1">
                  Alerts regarding the sending of prescriptions to pharmacies
                </Typography>
              </>
            }
          />
        </Typography>
        {loading ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <Formik
            initialValues={{
              writtenDate: rxalertsDetails[0]?.writtenDate ?? "",
              lastFilledDate: rxalertsDetails[0]?.lastFilledDate ?? "",
              drugDescription: rxalertsDetails[0]?.drugDescription ?? "",
              sig: rxalertsDetails[0]?.sig ?? "",
              daysSupply: rxalertsDetails[0]?.daysSupply ?? "",
              substitutionCode: rxalertsDetails[0]?.substitutionCode ?? "",
              qtyQualifier: rxalertsDetails[0]?.qtyQualifier ?? "",
              quantity: rxalertsDetails[0]?.quantity ?? "",
              refills: rxalertsDetails[0]?.refills ?? "",
              notes: rxalertsDetails[0]?.notes ?? "",
              pharmacyNote: rxalertsDetails[0]?.pharmacyNote ?? "",
            }}
            enableReinitialize
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {(registerProps) => (
              <Form onSubmit={registerProps.handleSubmit}>
                <PatientInfoCard
                  name={`${rxalertsDetails[0]?.patientFirstName} ${rxalertsDetails[0]?.patientLastName}`}
                  patientId={rxalertsDetails[0]?.patientId}
                  age={rxalertsDetails[0]?.age}
                  telePhone={rxalertsDetails[0]?.workPhone}
                  address={rxalertsDetails[0]?.patientAddress}
                  ssn={rxalertsDetails[0]?.ssn}
                  dateOfBirth={rxalertsDetails[0]?.dateOfBirth}
                  gender={rxalertsDetails[0]?.gender}
                />
                <Grid
                  container
                  item
                  xs={12}
                  spacing={0}
                  alignItems="top"
                  justifyContent="space-between"
                  columnSpacing={5}
                >
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="writtendate"
                      >
                        Written Date
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="writtendate"
                            name="writtenDate"
                            type="text"
                            className=""
                            disabled={true}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="lastfilleddate"
                      >
                        Last Filled Date
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="lastfilleddate"
                            name="lastFilledDate"
                            type="text"
                            className=""
                            disabled={true}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="drugdescription"
                      >
                        Drug Description
                      </Typography>{" "}
                      <Box display={{ xs: "flex", sm: "flex", md: "flex" }}>
                        <DRxInputStyle>
                          <DRxInput
                            id="drugdescription"
                            name="drugDescription"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.drugDescription}
                          />{" "}
                        </DRxInputStyle>
                        <HtmlTooltip
                          placement="right"
                          arrow
                          title={rxalertsDetails[0]?.deaClassCode}
                        >
                          <IconButton className="tooltip">
                            <img src={InfoIcon} alt="Tooltip" loading="lazy" />
                          </IconButton>
                        </HtmlTooltip>
                      </Box>{" "}
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="sig"
                      >
                        SIG
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="sig"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.sig}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="DaysSupply"
                      >
                        Days Supply{" "}
                        <Typography
                          component="span"
                          color={warnColor}
                          variant="body1"
                        >
                          *
                        </Typography>
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="daysSupply"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.daysSupply}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="Qualifier"
                      >
                        Qualifier{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="qtyQualifier"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.qtyQualifier}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="Quantity"
                      >
                        Quantity{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="quantity"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.quantity}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="Quantity"
                        marginTop={"0 !important"}
                      >
                        Total number of dispensings approved{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="refills"
                            type="text"
                            className=""
                            disabled={false}
                            value={registerProps.values.refills}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>{" "}
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="NoteFromPharmacy"
                        marginTop={"0 !important"}
                      >
                        Note From Pharmacy{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="pharmacyNote"
                            type="text"
                            className=""
                            disabled={true}
                            value={registerProps.values.pharmacyNote}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="Note"
                      >
                        Notes
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="notes"
                            type="text"
                            className=""
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="substitutionCode"
                      >
                        Substitutions
                      </Typography>
                      <Box>
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="substitutionCode"
                            id="substitutionCode"
                            options={
                              AllDropdwonsState?.substitutionCodeOptions ?? [
                                { value: "", label: "" },
                              ]
                            }
                            label="substitutionCode"
                            onChange={(option: any, e: any) => {
                              registerProps.setFieldValue(
                                "substitutionCode",
                                e.props.value
                              );
                            }}
                            value={registerProps.values.substitutionCode}
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LabelSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                      >
                        Pharmacy
                      </Typography>
                      <Box>
                        <Typography
                          component="div"
                          marginTop={1}
                          color="primary"
                          variant="body2"
                        >
                          {rxalertsDetails[0]?.pharmacyName}
                          <HtmlTooltip
                            placement="right"
                            arrow
                            title={<PharmacyDetails row={rxalertsDetails[0]} />}
                            className="w316"
                          >
                            <IconButton className="tooltip">
                              <img
                                src={InfoIcon}
                                alt="Tooltip"
                                loading="lazy"
                              />
                            </IconButton>
                          </HtmlTooltip>
                        </Typography>
                      </Box>
                    </LabelSMBoxStyle>
                  </Grid>
                  <Grid item xs={12}>
                    <BtnSMGroupStyle>
                      <YSButton
                        className={""}
                        children={"Back"}
                        onClick={() => history("/rxalerts")}
                        variant={"outlined"}
                        type={"button"}
                        size={"large"}
                        color="secondary"
                      />
                    </BtnSMGroupStyle>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        )}
      </ContentStyle>
    </>
  );
}
const PharmacyDetails = (props: any) => {
  const { row } = props;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyName)
            ? "Not Available"
            : row.pharmacyName}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyTwentyFourHourFlag)
            ? "Not Available"
            : row.pharmacyTwentyFourHourFlag}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyStoreNumber)
            ? "Not Available"
            : row.pharmacyStoreNumber}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyAddressLine1)
            ? "Not Available"
            : row.pharmacyAddressLine1}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Land Mark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyLandMark)
            ? "Not Available"
            : row.pharmacyLandMark}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyCity)
            ? "Not Available"
            : row.pharmacyCity}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyState)
            ? "Not Available"
            : row.pharmacyState}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyZip)
            ? "Not Available"
            : row.pharmacyZip}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyPhoneNumber)
            ? "Not Available"
            : row.pharmacyPhoneNumber}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {[null, ""].includes(row.pharmacyFaxNumber)
            ? "Not Available"
            : row.pharmacyFaxNumber}
        </Typography>
      </Grid>
    </Grid>
  );
};
